import { Device } from 'interfaces/deployment';
import axiosInstance from 'config/axios';
import { ColumnFilter, ColumnSort } from '@tanstack/react-table';

/**
 * @description Device response type
 * @type {DeviceResponse}
 */
export type DeviceResponse = {
  records: Device[];
  pageIndex: number;
  pageSize: number;
  totalPages: number;
};

/**
 * @description Devices service
 * @type {DevicesService}
 */
const DevicesService = {
  /**
   * @description Get all devices
   * @param {Object} queryParams - Query parameters
   * @returns {Promise<DeviceResponse>} Device response
   */
  getAll: (queryParams: {
    pageIndex: number;
    pageSize: number;
    sorting?: ColumnSort[];
    columnFilters?: ColumnFilter[];
  }) => {
    return axiosInstance.get<DeviceResponse>(`/v1/iot/devices`, {
      params: queryParams,
    });
  },
};

export default DevicesService;
